import { Plugin } from "..";
import { defaultTimeHistoryDataOptions } from "../time-history/time-history-data-options";
import { defaultSpectrumOptions, SpectrumOptionsV1, SpectrumOptionsV2 } from "./spectrum-options";

const id = "spectrum";

export const Spectrum: Plugin = {
	id,
	type: "cursor",
	header: {
		visible: true,
		edit: true,
		fullscreen: true,
	},
	name: "spectrum",
	component: defineAsyncComponent(() => import("./SpectrumPlugin.vue")),
	config: defineAsyncComponent(() => import("./SpectrumPluginConfig.vue")),
	dataConfig: defineAsyncComponent(() => import("./SpectrumDataConfig.vue")),
	defaultDataResolver: () => defaultTimeHistoryDataOptions,
	defaultOptionsResolver: () => defaultSpectrumOptions,
	dimension: {
		minHeight: 4,
		minWidth: 8,
	},

	currentVersion: 2,
	migrations: {
		1: ({ data, options }) => {
			const v1Options = options as SpectrumOptionsV1;
			const v2Options: SpectrumOptionsV2 = {
				...v1Options,
				axes: {
					...v1Options.axes,
					left: {
						...v1Options.axes.left,
						logScale: false,
					},
					right: {
						...v1Options.axes.right,
						logScale: false,
					},
				},
			};

			return { data, options: v2Options };
		},
	},
};
